import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Validations } from '../common_helper/Validations';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { LoginService } from './login.service';
import { Route } from '@angular/compiler/src/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  submitted: boolean = false;

  constructor(
    private titleService: Title,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private router: Router
  ) { }

  ngOnInit() {
    this.titleService.setTitle("Login");
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(Validations.email_pattern)]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)])
    })
  }

  submitLoginForm(){
    this.submitted = true;
    let params = {
      email:this.loginForm.value.email.toLowerCase(),
      password:this.loginForm.value.password,
    }
    if(this.loginForm.valid){
      this.spinner.show();
      this.loginService.login(params).subscribe(result => {
        if(result.status == 200){
          this.spinner.hide();
          this.toastr.success('', result.message);
          localStorage.setItem('adminDetails', JSON.stringify(result.data));
          this.router.navigate(['/user-management'])
        }else{
          this.spinner.hide();
          this.toastr.error('', result.message)
        }
      },
      err => {
        this.spinner.hide();
        this.toastr.error('', err.error.message);
      })
    }
  }

}
